// src/components/SellCar/SellCarCity.jsx

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function SellCarCity() {
  const { city } = useParams();
  const navigate = useNavigate();

  // ✅ Redirect any /sell-car/:city → /sell-car/:city/journey
  useEffect(() => {
    if (city) {
      navigate(`/sell-car/${city}/journey`, { replace: true });
    }
  }, [city, navigate]);

  return null;
}